import classNames from "classnames/bind";
import React from "react";
import styles from "../DateSelector.module.scss";
import type {
  DateRangeValue,
  DateSelectorMenuContentProps,
  DateValue,
  DateVariant,
} from "../types";
import DayPicker from "./DayPicker";
import MonthPicker from "./MonthPicker";
import WeekPicker from "./WeekPicker";
import YearPicker from "./YearPicker";

const cx = classNames.bind(styles);

const PickerComponent = ({
  variant,
  value,
  onChange,
  isClearable = false,
  ...commonProps
}: {
  variant: DateVariant;
  value?: DateValue | DateRangeValue;
  onChange:
    | ((newValue: DateValue | undefined) => void)
    | ((newValue: DateRangeValue | undefined) => void);
  isClearable?: boolean;
  isRange: boolean;
  onClose: () => void;
}) => {
  switch (variant) {
    case "time":
    case "day":
      return (
        // @ts-expect-error: https://github.com/microsoft/TypeScript/issues/19360
        <DayPicker
          {...commonProps}
          isWithTime={variant === "time"}
          value={value}
          onChange={onChange}
          isClearable={isClearable}
        />
      );
    case "week":
      return (
        <WeekPicker
          {...commonProps}
          value={value as DateRangeValue}
          onChange={onChange as (newValue: DateRangeValue | undefined) => void}
          isClearable={isClearable}
        />
      );
    case "month":
      return (
        <MonthPicker
          {...commonProps}
          value={value as DateRangeValue}
          onChange={onChange as (newValue: DateRangeValue | undefined) => void}
          isClearable={isClearable}
        />
      );
    case "year":
      return (
        <YearPicker
          {...commonProps}
          value={value as DateRangeValue}
          onChange={onChange as (newValue: DateRangeValue | undefined) => void}
          isClearable={isClearable}
        />
      );
  }
};

const DateSelectorMenuContent = ({
  value,
  variant,
  onChange,
  isRange,
  min,
  max,
  onClose,
  isClearable = false,
}: DateSelectorMenuContentProps) => {
  return (
    <>
      <div className={cx("menuContainer")}>
        <PickerComponent
          {...{
            value,
            variant,
            onChange,
            isRange,
            min,
            max,
            onClose,
            isClearable,
          }}
        />
      </div>
    </>
  );
};

export default DateSelectorMenuContent;
